import React, { useContext } from "react";
import { StatusGanttVariantType } from "@components/index";
import { MetricsResponse } from "@pages/Dashboard/hooks/useSidebarMetrics";

export enum CategoryEnum {
  queue,
  progress,
  late,
  finished,
}

export enum ViewsEnum {
  grid,
  gantt,
  detalhada,
}

export type StatusFilterType = StatusGanttVariantType | "late";

export type DrawerFilters = {
  status: StatusFilterType[];
  channels: string[];
  critical: string[];
};

type FilterContextType = {
  filter?: Sentinel.Enumerators.ProcessExecutionStatus[];

  category?: CategoryEnum;
  setCategory?: React.Dispatch<React.SetStateAction<CategoryEnum>>;

  date?: Date;
  setDate?: React.Dispatch<React.SetStateAction<Date>>;

  view?: ViewsEnum;
  setView?: React.Dispatch<React.SetStateAction<ViewsEnum>>;

  sidebarMetrics?: MetricsResponse;
  setSidebarMetrics?: React.Dispatch<React.SetStateAction<MetricsResponse>>;
};

const FilterContext = React.createContext<FilterContextType>({});

export const useFilterContext = () => useContext(FilterContext);

export default FilterContext;
